import { render, staticRenderFns } from "./BadgeFilters.vue?vue&type=template&id=36f535eb&scoped=true&"
import script from "./BadgeFilters.vue?vue&type=script&lang=js&"
export * from "./BadgeFilters.vue?vue&type=script&lang=js&"
import style0 from "./BadgeFilters.vue?vue&type=style&index=0&id=36f535eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f535eb",
  null
  
)

export default component.exports